module.exports = __webpack_public_path__ + "static/media/isolated-thunderstorms-day.d56a2be7.svg";